var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.611,
    height: 66.5,
    viewBox: "0 0 73.611 66.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.642,
    y1: 0.015,
    x2: 0.618,
    y2: 0.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Application_Development",
    "data-name": "Web Application Development",
    transform: "translate(-0.75 -2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9720",
    "data-name": "Path 9720",
    d: "M16.222,57.333H34v3.556H30.444a3.556,3.556,0,1,0,0,7.111H44.667a3.556,3.556,0,1,0,0-7.111H41.111V57.333H58.889A14.264,14.264,0,0,0,73.111,43.111V18.222A14.264,14.264,0,0,0,58.889,4H16.222A14.264,14.264,0,0,0,2,18.222V43.111A14.264,14.264,0,0,0,16.222,57.333Zm42.667-7.111H16.222a6.882,6.882,0,0,1-6.044-3.556H64.933A6.882,6.882,0,0,1,58.889,50.222ZM16.222,11.111H58.889A7.132,7.132,0,0,1,66,18.222V39.556H9.111V18.222A7.132,7.132,0,0,1,16.222,11.111Z",
    stroke: "#fff",
    strokeWidth: 2.5,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9721",
    "data-name": "Path 9721",
    d: "M15.178,27.267a3.228,3.228,0,0,0,2.489,1.067,3.228,3.228,0,0,0,2.489-1.067,3.437,3.437,0,0,0,0-4.978l-4.622-4.622,4.622-4.622a3.437,3.437,0,0,0,0-4.978,3.437,3.437,0,0,0-4.978,0L8.067,15.178a3.437,3.437,0,0,0,0,4.978l7.111,7.111Zm14.222,0a3.841,3.841,0,0,0,2.489,1.067,3.841,3.841,0,0,0,2.489-1.067l7.111-7.111a3.437,3.437,0,0,0,0-4.978L34.378,8.067a3.437,3.437,0,0,0-4.978,0,3.437,3.437,0,0,0,0,4.978l4.622,4.622L29.4,22.289a3.437,3.437,0,0,0,0,4.978Z",
    transform: "translate(12.778 7.667)",
    stroke: "#fff",
    strokeWidth: 2.5,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebapp);
export default __webpack_public_path__ + "static/media/webapp.50d0c94cf06c8ec83deceefc4618a2dc.svg";
export { ForwardRef as ReactComponent };